import axios from "axios";
// import url from "../config/urlServiceConfig";

const dashboardAPI = {
  getBalanceScore: (id, params) =>
    axios.get(`BalanceScoreStrategy/${id}`, { params }),
  getStrategyByID: (id, body) => axios.post(`StrategyMap/${id}`, body),
  getObjectiveByID: (id, body) =>
    axios.post(`StrategyMap/Objective/${id}`, body),
  showHideSections: (body) => axios.post(`UpdateUserStrategyView`, body),
};

export default dashboardAPI;
